export interface IDashContacts {
    id: number,
    source: string,
    organType: string,
    centerAlias: string, 
    centerId: number,
    firstName: string,
    lastName: string, 
    city: string,
    state: string, 
    postalCode: string, 
    gender: string,
    email: string,
    age: string,
    daysPending: string, 
    currentStatus: string,
}